import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatSliderChange } from "@angular/material/slider";
import { round } from "@helpers/utils";

@Component({
	selector: "bp-slider",
	templateUrl: "./bp-slider.component.html",
	styleUrls: ["./bp-slider.component.scss"],
	standalone: false
})
export class BpSliderComponent {
	private _sliderValue: number = 0;
	private _min: number = 0;
	private _max: number = 100;
	private _step: number = 1;

	@Input()
	public set model(n: number) {
		if (n.toString().length > 4) {
			this._model = round(n, 0);
		} else {
			this._model = n;
		}
	}
	public get model(): number {
		return this._model;
	}

	private _model: number = 0;

	// Current value
	@Input()
	public set sliderValue(val: number) {
		this._sliderValue = val;
	}
	public get sliderValue(): number {
		return this._sliderValue;
	}

	@Output()
	// TODO: eslint fix
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public valueChange: EventEmitter<any> = new EventEmitter<any>();

	// Minimum
	@Input()
	public set min(val: number) {
		this._min = val;
		this.restrictMargins();
	}
	public get min(): number {
		return this._min;
	}

	@Input()
	public isMatSlider: boolean = false;

	// Maximum
	@Input()
	public set max(val: number) {
		this._max = val;
		this.restrictMargins();
	}
	public get max(): number {
		return this._max;
	}

	// Maximum
	@Input()
	public set step(val: number) {
		this._step = val;
	}
	public get step(): number {
		return this._step;
	}

	private restrictMargins(): void {
		if (this.sliderValue < this.min) {
			this.sliderValue = this.min;
		}
		if (this.sliderValue > this.max) {
			this.sliderValue = this.max;
		}
	}

	@Input("showValue")
	public showValue: boolean = true;

	public sliderValueChange(e: MatSliderChange): void {
		this.model = e.value;
		this.selectedChange.emit(this.model);
	}

	@Output()
	public selectedChange: EventEmitter<number> = new EventEmitter<number>();

	@Input()
	public tickInterval: number = 0;
}
